import Image from 'next/image';
import React from 'react';
import { useRouter } from 'next/router';

const BusinessCard = (props: any) => {
  const { title, desc, image } = props;
  const router = useRouter();

  const getCategorySlug = (categoryTitle: string) => {
    const slugMap: Record<string, string> = {
      'Trứng tươi': 'trung-tuoi',
      'Trứng bóc vỏ sẵn': 'trung-an-lien',
    };
    return slugMap[categoryTitle] || '';
  };

  const handleClick = () => {
    // Nếu là "Gia công bóc vỏ số lượng lớn" thì điều hướng đến trang liên hệ
    if (title === 'Gia công bóc vỏ số lượng lớn') {
      router.push('/contact');
      return;
    }
    const slug = getCategorySlug(title);
    router.push(`/products${slug ? `#${slug}` : ''}`);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className="w-full col-span-1 h-[300px] md:h-[450px] relative rounded-2xl overflow-hidden group cursor-pointer shadow-lg hover:shadow-xl transition-all duration-500"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`Xem sản phẩm ${title}`}
    >
      <div className="absolute inset-0 z-0">
        <Image
          src={image}
          alt={title}
          fill
          style={{ objectFit: 'cover' }}
          className="md:group-hover:scale-110 duration-700 transform transition-all"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent md:group-hover:from-black/90 md:group-hover:via-black/50 transition-all duration-500" />
      </div>
      
      <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8 z-10">
        <div className="transform md:translate-y-24 md:group-hover:translate-y-0 transition-all duration-500">
          <h3 className="text-white text-[18px] md:text-[24px] font-bold uppercase mb-3 md:group-hover:text-primary transition-colors duration-300">
            {title}
          </h3>
          <p className="text-white/90 text-[14px] md:text-[16px] leading-relaxed max-w-md opacity-100 md:opacity-0 md:group-hover:opacity-100 transform md:translate-y-4 md:group-hover:translate-y-0 transition-all duration-500 delay-100">
            {desc}
          </p>
        </div>
        
        <div className="mt-4 flex items-center gap-2 opacity-100 md:opacity-0 md:group-hover:opacity-100 transform md:translate-x-[-20px] md:group-hover:translate-x-0 transition-all duration-500 delay-200">
          <div className="w-12 md:w-0 md:group-hover:w-12 h-[2px] bg-primary transition-all duration-300" />
          <span className="text-primary text-sm font-semibold uppercase tracking-wider">
            Tìm hiểu thêm
          </span>
        </div>
      </div>
      
      {/* <div className="absolute top-4 right-4 w-12 h-12 rounded-full bg-primary/20 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transform scale-0 group-hover:scale-100 transition-all duration-500 delay-300">
        <svg
          className="w-6 h-6 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div> */}
    </div>
  );
};

export default BusinessCard;
